module.exports = __webpack_public_path__ + "img/anre-logo-300.ff2edf6d.png";